import { isAxiosError } from "axios"
import { isErrorResponse } from "../../models/errorResponse"

export function isErrorKeyEquals(e: unknown, key: string) {
    return (
        isAxiosError(e) &&
        e.response &&
        e.response.data &&
        isErrorResponse(e.response.data) &&
        e.response.data.error.key === key
    )
}
